// extracted by mini-css-extract-plugin
export default {"Container":"denied_Container__Hsu3y","modal":"denied_modal__GSbDC","bounce":"denied_bounce__-b2P-","overlay":"denied_overlay__3wZbW","wrapper":"denied_wrapper__2JW4M"};